import React, { Component } from 'react';
import { connect } from 'react-redux';
import { submitAndSignOut } from '../../../userauth/actions/signinAction';
import { readCookie } from '../../../components/common/Cookie';
import { alphanumericValidator, isValidCSAId } from '../../../utils/sisUtils';
import CLEVERTAP_EVENT_NAMES from '../../../modules/ajio-util/cleverTap/eventConstants';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import AddressBox from '../../../myaccount/components/responsive/AddressBox';
import { isOrderPickup } from '../../../utils/common';
import properties from '../../../modules/ajio-util/properties';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import luxeScreens from '../../../refresh/constants/luxeScreenType';

class OrderDetailsSummary extends Component {
  constructor(props) {
    super(props);
    this.textResources = {
      shopBtn: 'Continue Shopping',
      homeLink: '/'
    };
    this.state = {
      employeeId: '',
      employeeIdSubmitted: false,
      visibleEmployeeSubmissionForm: false,
      csaError: ''
    };
  }

  componentWillMount() {
    const {isServerRendering = false } = this.props;

  }

  signOut() {
    if (isValidCSAId(this.state.employeeId)) {
      this.props.submitAndSignOut({
        callback: () => {
          this.setState({ employeeId: '', employeeIdSubmitted: true });
        },
        employeeId: this.state.employeeId,
        logout: false
      });
    } else {
      this.setState({ csaError: 'Please enter a valid Employee Id' });
    }
  }

  componentDidMount() {
    const { code = '' } = this.props;
    if (!sessionStorage[code]) {
      cleverTapPushEvent({
        eventName: CLEVERTAP_EVENT_NAMES.Charged
      });
      sessionStorage[code] = true;
    }
  }

  _changeInput(event) {
    let val = event.target.value;
    val = alphanumericValidator(val);
    if (val.length > 8) {
      val = val.substr(0, 8);
    }
    this.setState({ employeeId: val, csaError: '' });
  }

  render() {
    let {
      name = '',
      code = '',
      statusDisplay = '',
      isMobile = false,
      deliveryModeValue,
      deliveryAddress,
      newDesignLuxe
    } = this.props;
    const {
      employeeIdSubmitted = false,
      visibleEmployeeSubmissionForm = false,
      csaError
    } = this.state;
    const {
      luxeStore,
      orderConfirmation: { screenName = '', screenType = '' }
    } = luxeScreens;
 
    const pickupOrder = isOrderPickup({ deliveryModeValue });
    return (
      <div className="order-summary-section">
        <div aria-label={`Thank you ${name}, for placing an order with us. Your order`}>
          Thank you {name}, for placing an order with us. Your order
          <a href={`/my-account/order-details?orderId=${code}`} className="bolder" aria-label={code}>
            <strong> {code}</strong>
          </a>{' '}
          is confirmed
          <div aria-label={statusDisplay}>{statusDisplay}</div>
          {visibleEmployeeSubmissionForm && (
            <div className="assistant-id">
              {!employeeIdSubmitted ? (
                <section>
                  <span className="assistant-id-info" aria-label='Enter the Employee Id of the assistant who helped you'>
                    Enter the Employee Id of the assistant who helped you{' '}
                  </span>
                  <input
                    placeholder="Optional"
                    onChange={this._changeInput.bind(this)}
                    value={this.state.employeeId}
                  />
                  <button
                    className={this.state.employeeId.length > 0 ? 'active' : 'inactive'}
                    onClick={this.signOut.bind(this)}
                  >
                    Submit
                  </button>
                  {csaError && <div className="csa-error">{csaError}</div>}
                </section>
              ) : (
                <p className="success-employee-id-submission-message" aria-label='Successfully submitted assistant information.'>
                  Successfully submitted assistant information.
                </p>
              )}
            </div>
          )}
        </div>
        {!isMobile && (
          <div className="shopping-btn">
            <a
              aria-label={this.textResources.shopBtn} href={this.textResources.homeLink}
              onClick={() => {
                if (newDesignLuxe) {
                  gtmEventPush({
                    event: 'order_confirm_interaction',
                    event_category: 'order confirmation interactions',
                    event_action: 'user interactions',
                    event_label: 'continue shopping clicked',
                    page_type: screenType,
                    store_type: luxeStore
                  });
                }
              }}
            >
              <strong>{this.textResources.shopBtn}</strong>
            </a>
          </div>
        )}
        {isMobile && (
          <div className="address-section thank-you-page">
            <AddressBox address={deliveryAddress} isPageType="orderDetails" />
            {pickupOrder && (
              <img
                src={`${properties.getProperty('imageBaseUrl')}/static/img/pickFromStoreTag.svg`}
                className="pickTag"
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    submitAndSignOut: data => {
      dispatch(submitAndSignOut(data));
    }
  };
};

export default connect(null, mapDispatchToProps)(OrderDetailsSummary);
